import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { ChartBar } from "@phosphor-icons/react";

import AssessmentBanner from "./AssessmentBanner";
import { getAssessmentDefinition } from "../assessmentConfig";
import { description, assessmentCard, space5, space3 } from "../styled";

const vinelandDefinition = getAssessmentDefinition("vineland");

export default function EmptyAssessments() {
  const { t } = useTranslation(["clientHeader"]);

  const translatedVinelandDefinition = {
    ...vinelandDefinition,
    title: t("clientHeader:assessments.vinelandTitle"),
    description: t("clientHeader:assessments.vinelandDescription"),
    primaryActionLabel: t("clientHeader:assessments.viewScores"),
  };

  return (
    <Box flexGrow={4} p={space5}>
      <Typography variant="body2" sx={description}>
        {t("clientHeader:assessments.manageRecords")}
      </Typography>

      <Box sx={assessmentCard}>
        <AssessmentBanner
          definition={translatedVinelandDefinition}
          onViewScores={() => {}}
          onAddAssessment={() => {}}
          hideActions
        />
        <Typography component="h3" variant="body2" align="center" p={space5} gutterBottom={false}>
          <ChartBar
            size={20}
            weight="duotone"
            style={{ verticalAlign: "top", marginRight: space3 }}
          />
          <span>{t("clientHeader:assessments.noAssessments")}</span>
        </Typography>
      </Box>
    </Box>
  );
}
